import axios from 'axios';
import { useEffect } from 'react';
import { useAuthAxiosInterceptorFunction } from './useAuthAxiosInterceptorFunction';
/** This effect causes Axios to request fresh tokens on request. */
export const useAuthAxiosInterceptorEffect = (enabled = true) => {
    const axiosInterceptor = useAuthAxiosInterceptorFunction();
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const id = axios.interceptors.request.use(axiosInterceptor);
        return () => {
            axios.interceptors.request.eject(id);
        };
    }, [enabled, axiosInterceptor]);
};
